/* facts-scroller.js · generische Blaetter-Mechanik fuer facts-* Sections
 * ------------------------------------------------------------------
 * Attribut-gesteuert statt klassen-gebunden, damit jede weitere Section
 * dieselbe Datei benutzen kann:
 *   [data-facts-rail]      Wurzel (die Section)
 *   [data-facts-scroller]  das Element, das wirklich scrollt
 *   [data-facts-prev/next] Blaetter-Tasten
 *   [data-facts-item]      eine Karte, liefert die Schrittweite
 *
 * Drei Aufgaben, mehr nicht: Blaettern mit korrektem Aktiv/Inaktiv-Zustand,
 * Ziehen mit der Maus, Pfeiltasten.
 *
 * Zwei Regeln aus dem Section-Standard stecken hier drin:
 *  - Im Scroll-Listener NIE direkt messen. scrollWidth/clientWidth erzwingen
 *    Layout, und zwar pro Ereignis. Alles gebuendelt in einem rAF.
 *  - Ueberlauf allein ist KEIN Scroll-Container: ein Block mit
 *    overflow:visible und breiterem Kind erfuellt die Bedingung und laesst
 *    sich trotzdem nicht scrollen. Die Ueberlaufeigenschaft mitpruefen.
 */
(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');

  function activeScroller(root) {
    var all = root.querySelectorAll('[data-facts-scroller]');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      var ox = getComputedStyle(el).overflowX;
      if (ox !== 'auto' && ox !== 'scroll') continue;
      if (el.scrollWidth - el.clientWidth > 2) return el;
    }
    return null;
  }

  function step(el) {
    var item = el.querySelector('[data-facts-item]');
    if (!item) return Math.round(el.clientWidth * 0.8);
    var cs = getComputedStyle(el);
    var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
    return Math.round(item.getBoundingClientRect().width + gap);
  }

  function init(root) {
    var prev = root.querySelector('[data-facts-prev]');
    var next = root.querySelector('[data-facts-next]');
    var frame = 0;

    function sync() {
      frame = 0;
      if (!prev || !next) return;
      var el = activeScroller(root);
      if (!el) { prev.disabled = true; next.disabled = true; return; }
      var max = el.scrollWidth - el.clientWidth;
      prev.disabled = el.scrollLeft <= 2;
      next.disabled = el.scrollLeft >= max - 2;
    }
    function queue() { if (!frame) frame = requestAnimationFrame(sync); }

    function go(dir) {
      var el = activeScroller(root);
      if (!el) return;
      el.scrollBy({ left: dir * step(el), behavior: RM.matches ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    var rails = root.querySelectorAll('[data-facts-scroller]');
    for (var i = 0; i < rails.length; i++) {
      (function (el) {
        el.addEventListener('scroll', queue, { passive: true });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        });

        /* Ziehen mit der Maus. Nur bei feinem Zeiger - auf Touch macht das der
         * Browser besser. Ab 4px Weg gilt es als Ziehen, dann werden die Links
         * stillgelegt, damit das Loslassen keine Navigation ausloest. */
        var down = false, startX = 0, startL = 0, moved = false;
        el.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          down = true; moved = false; startX = e.clientX; startL = el.scrollLeft;
        });
        el.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - startX;
          if (!moved && Math.abs(dx) < 4) return;
          if (!moved) { moved = true; el.classList.add('is-drag'); el.setPointerCapture(e.pointerId); }
          el.scrollLeft = startL - dx;
        });
        function end() {
          if (!down) return;
          down = false;
          if (moved) setTimeout(function () { el.classList.remove('is-drag'); }, 0);
        }
        el.addEventListener('pointerup', end);
        el.addEventListener('pointercancel', end);
        el.addEventListener('pointerleave', end);
      })(rails[i]);
    }

    if (window.ResizeObserver) new ResizeObserver(queue).observe(root);
    window.addEventListener('resize', queue, { passive: true });
    queue();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-facts-rail]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].dataset.factsReady) continue;
      roots[i].dataset.factsReady = '1';
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
